import { subscribeWithSelector, persist, createJSONStorage } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

const noopStorage = {
  getItem: _key => '',
  setItem: (_key, _value) => {
    //
  },
  removeItem: _key => {
    //
  }
};
function createStorage({
  storage = noopStorage,
  key: prefix = 'livepeer'
}) {
  return {
    getItem: async (key, defaultState = null) => {
      try {
        const value = await storage.getItem(`${prefix}.${key}`);
        return value ? JSON.parse(value) : defaultState;
      } catch (error) {
        console.warn(error);
        return defaultState;
      }
    },
    setItem: async (key, value) => {
      if (value === null) {
        await storage.removeItem(`${prefix}.${key}`);
      } else {
        try {
          await storage.setItem(`${prefix}.${key}`, JSON.stringify(value));
        } catch (err) {
          console.error(err);
        }
      }
    },
    removeItem: async key => storage.removeItem(`${prefix}.${key}`)
  };
}

const storeKey = 'livepeer-store';
class Client {
  constructor({
    provider,
    storage = createStorage({})
  }) {
    // Create store
    this.store = createStore(subscribeWithSelector(persist(() => ({
      provider: provider()
    }), {
      name: storeKey,
      storage: createJSONStorage(() => storage),
      // for now, we don't store any state in local storage
      partialize: _state => ({}),
      version: 1
    })));
    this.config = {
      provider,
      storage
    };
    this.storage = storage;
  }
  get error() {
    return this.store.getState().error;
  }
  get provider() {
    return this.store.getState().provider;
  }
  get subscribe() {
    return this.store.subscribe;
  }
  setState(updater) {
    const newState = typeof updater === 'function' ? updater(this.store.getState()) : updater;
    this.store.setState(newState, true);
  }
  clearState() {
    this.setState(x => ({
      ...x,
      data: undefined,
      error: undefined
    }));
  }
  async destroy() {
    this.clearState();
    this.store.destroy();
  }
}
let client = null;
function createClient(config) {
  const client_ = new Client(config);
  client = client_;
  return client_;
}
function getClient() {
  if (!client) {
    throw new Error('No livepeer client found.');
  }
  return client;
}
function clearClient() {
  client = null;
}

export { Client as C, createClient as a, createStorage as b, clearClient as c, getClient as g, noopStorage as n };
